<div class="block-wrapper">
  <div *ngIf="blocksConfig.editable && block?.url?.length > 0" class="overlay" [class.overlay-active]="!blockSelected">
  </div>

  <div class="w-100 d-flex flex-column" [ngClass]="{'embed-responsive embed-responsive-16by9': block?.url?.length > 0}">
    <iframe *ngIf="block?.url && block?.url.length > 0" id="player" type="text/html" [class.disabled]="!blocksConfig.interactive"
            [style.width.%]="100" height="500" [src]="sanitizedUrl" frameborder="0"></iframe>

    <div *ngIf="(!block.url || block?.url.length === 0) && blocksConfig.editable"
         class="placeholder position-relative text-center">
      <pl-icon class="icon" icon="builderVideo" style="width: 24px"></pl-icon>
      <p class="header mt-2 mb-0">{{'blocks.' + block.type + '.no_video' | transloco}}</p>
      <p class="subheader mt-1 mb-0 text-muted">{{'blocks.' + block.type + '.paste_info' | transloco}}</p>
    </div>
  </div>
</div>

